// extracted by mini-css-extract-plugin
export default {"workOrder":"WorkOrder_workOrder__eSJ2J","tabHeader":"WorkOrder_tabHeader__Rxfx-"};